'use client';

import React, { useCallback, useState } from 'react';
import CustomerApiService from '@/services/CustomerApiService';

interface SplitPayButtonProps {
  reservationId: number;
  splitId: number;
  paymentUrl?: string | null;
  label: string;
  loadingLabel: string;
  className?: string;
  onError?: (message: string) => void;
}

export default function SplitPayButton({
  reservationId,
  splitId,
  paymentUrl,
  label,
  loadingLabel,
  className = 'inline-flex items-center rounded-lg bg-alsero-first px-3 py-1.5 text-xs font-semibold text-white hover:bg-alsero-second transition-colors disabled:opacity-60',
  onError,
}: SplitPayButtonProps) {
  const [loading, setLoading] = useState(false);

  const handlePay = useCallback(async () => {
    if (paymentUrl) {
      window.location.href = paymentUrl;
      return;
    }
    setLoading(true);
    try {
      const { payment_url } = await CustomerApiService.getReservationSplitPaymentLink(reservationId, splitId);
      window.location.href = payment_url;
    } catch (err) {
      onError?.(err instanceof Error ? err.message : 'Payment failed');
    } finally {
      setLoading(false);
    }
  }, [paymentUrl, reservationId, splitId, onError]);

  return (
    <button type="button" onClick={() => void handlePay()} disabled={loading} className={className}>
      {loading ? loadingLabel : label}
    </button>
  );
}
